var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "bj-modal",
    {
      attrs: {
        title: "Change an agent to inquiry",
        size: { minWidth: "450px" }
      },
      model: {
        value: _vm.changeAnAgent.visible,
        callback: function($$v) {
          _vm.$set(_vm.changeAnAgent, "visible", $$v)
        },
        expression: "changeAnAgent.visible"
      }
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _vm.changeAnAgent.loading
          ? _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("q-spinner-puff", {
                  attrs: { color: "primary", size: "60px" }
                })
              ],
              1
            )
          : _c("div", { staticClass: "row gutter-sm align-items-center" }, [
              _c(
                "div",
                { staticClass: "col-9" },
                [
                  _c("autocomplete", {
                    attrs: {
                      method: "autocompleteAgent",
                      filters: {
                        is_tours_capable: true,
                        property_id:
                          _vm.get(
                            _vm.changeAnAgent,
                            "payload.inquiry.property_id"
                          ) ||
                          _vm.get(
                            _vm.changeAnAgent,
                            "payload.inquiry.tour.property_id"
                          )
                      },
                      placeholder: "Find an agent..."
                    },
                    on: { change: _vm.changeAnAgentSelected }
                  }),
                  _vm.prevAgent &&
                  _vm.changeAnAgent.payload.agent &&
                  _vm.prevAgent.id !==
                    _vm.get(_vm.changeAnAgent, "payload.agent.id")
                    ? _c("span", [
                        _vm._v(
                          "\n          Current agent/pm " +
                            _vm._s(_vm.prevAgent.full_name) +
                            " will receive a system cancellation message\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm.prevAgent &&
                  _vm.changeAnAgent.payload.agent &&
                  _vm.prevAgent.id ===
                    _vm.get(_vm.changeAnAgent, "payload.agent.id")
                    ? _c("span", [
                        _vm._v(
                          "\n          Please select a different agent from the currently selected one\n        "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("q-btn", {
                    attrs: {
                      disabled:
                        !_vm.changeAnAgent.payload.agent ||
                        _vm.get(_vm.prevAgent, "id") ===
                          _vm.get(_vm.changeAnAgent, "payload.agent.id"),
                      outline: "",
                      label: "Match!"
                    },
                    on: { click: _vm.submitChangeAnAgent }
                  })
                ],
                1
              )
            ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }